import { Component, Output, EventEmitter, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MapToolbarItem, OrganisationIdColour, Truck } from 'src/app/transportation/trucks/trucks.service';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { MaterialAutoCompleteComponent } from 'src/app/shared/components/material-autocomplete/material-auto-complete.component';
import { MaterialDateRangeComponent, DateRange } from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { OrganisationService } from 'src/app/organisation/organisation.service';

@Component({
  selector: 'app-map-toolbar',
  templateUrl: './map-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    SharedModule,
    MaterialAutoCompleteComponent,
    MaterialDateRangeComponent,
    MatButtonModule,
    MatSelectModule,
    MaterialOrganisationSelectorComponent
  ],
})

export class MapToolbarComponent implements OnDestroy {
  @Output()
    selectedOrganisationId: EventEmitter<string> = new EventEmitter<string>();
  @Output()
    recenter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
    zoomOut: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
    showOutOfReachTruck: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
    showAvailableTrucks: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
    colorCodeByOrganisation: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
    colorCodeByTimestamp: EventEmitter<number> = new EventEmitter<number>();
  @Output()
    daterange: EventEmitter<DateRange> = new EventEmitter<DateRange>();
  @Output()
    clusterTrucks: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
    selectedTruck: EventEmitter<Truck> = new EventEmitter<Truck>();

  _numberOfUnavailableTrucks?: number;
  _numberOfAvailableTrucks?: number;
  _showInformationPanel: boolean = false;
  _colorCodeByOrganisation = false;
  _colorCodeByTimestamp?: number;
  _clusterTrucks = false;
  _selectedOrganisationId?: Organisation;
  _selectedTruck?: Truck;
  organisationsColours: OrganisationIdColour[] = [];
  showTools: boolean = false;
  trucks: Truck[] = [];
  filteredTrucks: Truck[] = [];
  organisations?: Organisation[];
  selectedDate: DateRange;
  dateRange: DateRange = {
    startDate: new Date(),
    endDate: new Date(),
  };

  showReportLink = false;

  showDaterange = false;

  toolbarItem?: MapToolbarItem;

  private eventsSubscription?: Subscription;

  constructor(
    private _router: Router,
    private _organisationService: OrganisationService,
  ) {
    this.selectedDate = { startDate: new Date(), endDate: new Date() };
  }

  ngOnDestroy() {
    if (this.eventsSubscription) {
      this.eventsSubscription.unsubscribe();
    }
  }

  truckListFormatter(truck: Truck) {
    if (truck) {
      const driver =
      (truck.driver)
        ? truck.driver.associatedObject.name
        : 'N/A';
      const tanker =
      (truck.tanker)
        ? truck.tanker.associatedObject.number
        : 'N/A' ;
      return truck.formattedRegistrationNumber + '***' + tanker + '***' + driver;
    }
    return '';
  }

  truckValueFormatter(truck: Truck) {
    return truck.formattedRegistrationNumber;
  }

  tools(t: string) {
    if (t === 'show') {
      this.showTools = true;
    } else {
      this.showTools = false;
    }
  }

  showAll() {
    this.showReportLink = false;
    this.recenter.emit();
    this.showDaterange = false;
    this._selectedOrganisationId = undefined;
    this._selectedTruck = undefined;
    this.filteredTrucks = [...this.trucks];
  }

  zoomOutMap() {
    this.zoomOut.emit();
  }

  showOutOfReach() {
    this.showOutOfReachTruck.emit();
  }

  showAvailables() {
    this.showAvailableTrucks.emit();
  }

  date(dr: DateRange) {
    if (dr) {
      this.selectedDate = dr;
      this.daterange.emit(this.selectedDate);
    }
  }

  selectOrganisation(organisation: Organisation) {
    if (organisation) {
      this.filteredTrucks = this.trucks.filter(
        (truck) => truck.organisationId!.associatedObject === organisation.name
      );
    } else {
      this.filteredTrucks = this.trucks;
    }
    this.selectedOrganisationId.emit(organisation.name);
  }

  colorCodeOrganisation() {
    this._colorCodeByOrganisation = !this._colorCodeByOrganisation;
    this.colorCodeByOrganisation.emit(this._colorCodeByOrganisation);
  }

  colorCodeTimestamp() {
    this.colorCodeByTimestamp.emit(this._colorCodeByTimestamp);
  }

  cluster() {
    this._clusterTrucks = !this._clusterTrucks;
    this.clusterTrucks.emit(this._clusterTrucks);
  }

  selectTruck(truck: Truck) {
    if (truck && truck.formattedRegistrationNumber) {
      this.showReportLink = true;
      this._selectedTruck = truck;
      this.selectedTruck.emit(truck);
      this.showDaterange = true;
    }
  }

  reportInDetail() {
    const now = new Date().getTime();
    const aWeekBefore = now - 48 * 3600 * 1000;
    this._router.navigate([
      '/trucks/report',
      this._selectedTruck?.tracker?.associatedObject.imei,
      aWeekBefore,
      now,
    ]);
  }

}
